type SP = string | string[] | undefined | null;

function first(v: SP): string | undefined | null {
  if (Array.isArray(v)) return v[0];
  return v;
}
type NumericEnumLike = Record<string, string | number>;

const sp = {
  string(v: SP, opts?: { trim?: boolean; emptyAsUndefined?: boolean }) {
    let s = first(v);
    if (!s) return undefined;

    if (opts?.trim !== false) s = s.trim();
    if (opts?.emptyAsUndefined !== false && s === "") return undefined;

    return s;
  },

  int(v: SP, opts?: { min?: number; max?: number }) {
    const s = first(v);
    if (s == null) return undefined;

    const n = Number(s);
    if (!Number.isInteger(n)) return undefined;

    if (opts?.min != null && n < opts.min) return undefined;
    if (opts?.max != null && n > opts.max) return undefined;

    return n;
  },

  bool(v: SP) {
    const s = first(v)?.toLowerCase();
    if (s == null) return undefined;

    return s === "1" || s === "true" || s === "yes";
  },

  enum<T extends readonly string[]>(v: SP, values: T): T[number] | undefined {
    const s = first(v);
    return values.includes(s as any) ? (s as T[number]) : undefined;
  },

  enumNumber<E extends NumericEnumLike>(
    v: SP,
    enumObject: E,
  ): (E[keyof E] & number) | undefined {
    const raw = first(v);
    if (raw == null) return undefined;

    const n = Number(raw);
    if (!Number.isInteger(n)) return undefined;

    const numericValues = Object.values(enumObject).filter(
      (x): x is number => typeof x === "number",
    );

    return (numericValues.includes(n) ? n : undefined) as
      (E[keyof E] & number) | undefined;
  },

  intArray(v: SP, opts?: { min?: number; max?: number }) {
    const s = first(v);
    if (!s) return undefined;

    const arr = s
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean)
      .map((x) => Number(x))
      .filter((n) => Number.isInteger(n));

    if (!arr.length) return undefined;

    const filtered = arr.filter((n) => {
      if (opts?.min != null && n < opts.min) return false;
      if (opts?.max != null && n > opts.max) return false;
      return true;
    });

    return filtered.length ? filtered : undefined;
  },
};

export default sp;
